import React from "react";
import * as styles from "./DetailsItem.module.scss";

const colorMap = {
  yellow: "#f7d000",
  blue: "#222aff",
  lightblue: "#1282e1",
  lightgrey: "#f3f3f3",
  orange: "#ff8924",
  black: "#000000",
  red: "#ea260c",
  green: "#00b979",
  grey: "#969696",
};

const DetailsItem = ({ icon, name, description, colorCategory }) => {
  const color = colorMap[colorCategory] || "#000";

  return (
    <div className={styles.item__container}>
      <div className={styles.icono__circle}>
        <img src={icon} alt={name} />
      </div>
      <div className={styles.item__name} style={{ color: color }}>
        <h5>{name}</h5>
      </div>
      <div className={styles.item__description}>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default DetailsItem;
